import Loader from 'src/components/molecules/loader'
import { Suspense } from 'react'

const Loading = () => {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <Loader />
    </div>
  )
}

export function RouteSuspense({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<Loading />}>{children}</Suspense>
}
